<template>
  <div class="mt-4 flex flex-col gap-3">
    <div
      v-for="i of 10"
      :key="i"
      class="bg-background-neutral-secondary flex h-28 w-full flex-col rounded-2xl px-4 py-3"
    >
      <div class="flex items-center justify-between">
        <div class="flex">
          <div class="shimmer mr-6 h-10 w-[100px] rounded-2xl"></div>
          <div class="shimmer h-10 w-[100px] rounded-2xl"></div>
        </div>
        <div class="shimmer h-[24px] w-[24px] rounded-full"></div>
      </div>
      <div
        class="border-situational-lightgrey my-2 w-full self-center border border-dashed bg-opacity-90"
      ></div>
      <div class="flex justify-between py-1">
        <div class="shimmer h-[22px] w-[113px] rounded-2xl"></div>
        <div class="shimmer h-[22px] w-[84px] rounded-2xl"></div>
      </div>
    </div>
  </div>
</template>
